export default {
  NONE: {
    Title: 'None',
    Color: '#000000',
  },
  LOW: {
    Title: 'Low',
    Color: '#C5231C',
  },
  MEDIUM: {
    Title: 'Medium',
    Color: '#C6A521',
  },
  HIGH: {
    Title: 'High',
    Color: '#50A30C',
  },
};
